import React, { useEffect, useState } from "react";

const JobSheetInvoicePage = ({ isVisible, jobSheetData }) => {
  const [dataIsReady, setdataIsReady] = useState(false);
  const invoiceDetails = jobSheetData?.invoiceInformationDetails;

  const executionRows =
    invoiceDetails
      ?.filter((x) => x.invoiceCategoryId === 1)
      .map((item) => [item.id, item.description]) || [];

  const materialRows =
    invoiceDetails
      ?.filter((x) => x.invoiceCategoryId === 2)
      .map((item) => [item.id, item.description]) || [];

  return (
    <div
      style={{
        width: "794px",
        height: "auto",
        backgroundColor: "white",
        pageBreakBefore: "always",
        padding: "40px 30px",
        fontFamily: "Arial, sans-serif",
        fontSize: "12pt",
        color: "#000",
        ...(!isVisible && dataIsReady && { display: "none" }),
      }}
    >
      <h1
        style={{ fontWeight: "bold", fontSize: "20pt", marginBottom: "24px" }}
      >
        Information for Invoicing
      </h1>

      {/* Execution Details Table */}
      {executionRows.length > 0 && (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "40px",
          }}
        >
          <thead>
            <tr>
              <th style={thStyle}>Execution Details</th>
              <th style={thStyle}></th>
              <th style={thCenterStyle}>OK</th>
              <th style={thCenterStyle}>UK</th>
              <th style={thCenterStyle}>Techniker</th>
            </tr>
          </thead>
          <tbody>
            {executionRows.map((text, idx) => (
              <tr key={idx}>
                <td style={tdStyle}>{text[0]}</td>
                <td style={tdStyle}>{text[1]}</td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>
                <td style={tdStyle}></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Material Details Table */}
      {materialRows.length > 0 && (
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={thStyle}>Material Details</th>
            <th style={{ ...thStyle, width: "30%", padding: "8px 10px" }}></th>
            <th style={{ ...thStyle, width: "50%", padding: "8px 10px" }}>Material-Number:</th>
          </tr>
        </thead>
        <tbody>
          {materialRows.map(([number, desc], idx) => (
            <tr key={idx}>
              <td style={tdStyle}>{number}</td>
              <td style={tdStyle}>{desc}</td>
              <td style={tdStyle}></td>
            </tr>
          ))}
        </tbody>
      </table>
      )}
    </div>
  );
};

// Shared style objects
const thStyle = {
  textAlign: "left",
  padding: "8px 6px 12px",
  fontWeight: "bold",
};

const thCenterStyle = {
  ...thStyle,
  textAlign: "center",
};

const tdStyle = {
  padding: "8px 6px",
  border: "1px solid #ccc",
  verticalAlign: "top",
};

export default JobSheetInvoicePage;
